import {
  type ForwardRefExoticComponent,
  useEffect,
  useRef,
  useState,
} from 'react';

import { useSplashTracking } from '../PageComponents/common/useSplashTracking';

export const withCarouselTracking =
  <T extends { pageComponentIndex?: number }>(
    Component: ForwardRefExoticComponent<T>
  ) =>
  (props: T) => {
    const carouselRef = useRef<HTMLDivElement>(null);

    const [isViewRegistered, setIsViewRegistered] = useState(false);

    const { pageComponentIndex } = props;
    const { trackSplashView } = useSplashTracking({
      elementType: 'MainCarousel',
      pageComponentIndex,
    });

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !isViewRegistered) {
            setIsViewRegistered(true);
          }
        },
        { threshold: 0.8 }
      );
      if (carouselRef.current) {
        observer.observe(carouselRef.current);
      }

      return () => observer.disconnect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      if (isViewRegistered) {
        trackSplashView();
      }
    }, [isViewRegistered]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Component {...props} ref={carouselRef} />;
  };
